module.exports = __webpack_public_path__ + "img/5.9ca7b75d.png";